import '../App.css';
import '../style.css';
import '../font.css';
import './style_works.css';
import { useEffect } from 'react';
import { setOgImage } from '../utils/setOgImage';

export function MainImage(props: {
    image: string; 
}) {
    useEffect(() => {
        if (props.image) setOgImage(props.image);
    }, [props.image]);

    return (
        <>
        <div style = {{maxHeight :"1200px",overflow:"hidden"  }}>
            <img style = {{ width:"100%", aspectRatio: "auto" }} src={props.image}/>
        </div>
        </>
    )
}